// src/pages/backoffice/Stats/TopBorrowersList/index.js
import { connect } from "react-redux";
import { fetchTopBorrowers } from "./state/actions";
import TopBorrowersListComponent from "./TopBorrowersList";

const mapStateToProps = (state) => {
  // Fix: Use consistent property names and provide better fallbacks
  const statsData = state.statsTopBorrowers || {};

  const mappedProps = {
    data: statsData.data || { hits: [], total: 0 },
    error: statsData.error || null,
    isLoading: statsData.isLoading || false,
    hasError: statsData.hasError || false,
  };

  return mappedProps;
};

const mapDispatchToProps = {
  fetchTopBorrowers,
};

export const TopBorrowersList = connect(
  mapStateToProps,
  mapDispatchToProps
)(TopBorrowersListComponent);
